// setup shop cart
$('#shop-cart').hoverIntent({
  timeout: 50,
  interval: 10,
  over: function() { this.className = 'hover'; },
  out: function() { this.className = 'no-hover'; }
})

// setup categories navigation
$('.top-nav > li').hoverIntent({
  timeout: 50,
  interval: 10,
  over: function() { this.className = 'open'; },
  out: function() { this.className = ''; }
})